const ITEMS = ["Vis", "Chevilles", "Wago", "Écrous", "Rondelles", "Colliers", "Petits raccords", "Consommables", "Joints", "Embouts"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-[#2E333D] bg-[#141619]/60 py-4 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {row.map((item, i) => (
          <span key={i} className="font-display uppercase text-lg tracking-[0.3em] text-gray-600 mx-6 flex items-center gap-6">
            {item} <span className="text-[#FFC700]/50 text-xs">●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
